import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center text-muted-foreground">
                Loading...
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    if (user.must_change_password && location.pathname !== "/change-password") {
        return <Navigate to="/change-password" replace />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}
